/**
 * UI Components PropTypes
 *
 * Centralized PropType definitions for reusable UI components throughout the application.
 * Includes buttons, alerts, toasts, feedback states, and other interactive UI elements.
 *
 * @module propTypes/ui-components
 */

import PropTypes from "prop-types";

/**
 * Button variant options
 * Defines all available visual styles for Button components
 */
export const buttonVariantPropType = PropTypes.oneOf([
  "primary",
  "secondary",
  "dark",
  "outline-primary",
  "outline-secondary",
  "ghost",
  "pill",
  "primary-bold",
  "cookie-outline",
  "cookie-accept",
]);

/**
 * Icon button variant options
 * Defines visual styles for IconButton components
 */
export const iconButtonVariantPropType = PropTypes.oneOf(["default", "danger", "ghost"]);

/**
 * Size options for buttons and UI components
 * Standard sizing: small, medium, large
 */
export const sizePropType = PropTypes.oneOf(["sm", "md", "lg"]);

/**
 * Alert and toast type options
 * Defines semantic types for feedback messages
 */
export const alertTypePropType = PropTypes.oneOf(["success", "error", "warning", "info"]);

/**
 * Toast position options
 * Defines where toast notifications appear on screen
 */
export const toastPositionPropType = PropTypes.oneOf([
  "top-right",
  "top-left",
  "bottom-right",
  "bottom-left",
  "top-center",
]);

/**
 * Quantity button action types
 * Increment or decrement actions for quantity controls
 */
export const quantityActionPropType = PropTypes.oneOf(["increment", "decrement"]);

/**
 * Button type attribute options
 * HTML button type values
 */
export const buttonTypePropType = PropTypes.oneOf(["button", "submit", "reset"]);

/**
 * Icon position relative to text in buttons
 */
export const iconPositionPropType = PropTypes.oneOf(["left", "right"]);
